import { customElement, html } from '@adobe/edex/ui/edex-lit';
import { EdexTagName } from '@adobe/edex/ui/shared/constants';
import { BaseAuthElement } from '../base.element';
import './emptyState.scss';

@customElement(EdexTagName.myEdexEmptyState)
export class MyEducationExchangeEmptyState extends BaseAuthElement {
  get useLightDom() {
    return true;
  }

  static get properties() {
    return {
      ...super.properties,
      iconSrc: { type: String },
      description: { type: String },
      buttonText: { type: String },
      buttonLink: { type: String },
      variant: { type: String },
      disabled: { type: Boolean },
      showButton: { type: Boolean },
    };
  }
  iconSrc = '';
  buttonText = '';
  buttonLink = '';
  description = '';
  variant = 'secondary';
  disabled = false;
  showButton = true;

  stateChanged(state) {
    super.stateChanged(state);
  }

  async connectedCallback() {
    super.connectedCallback();
  }

  renderButton() {
    const { buttonText, buttonLink, variant, showButton } = this;
    if (!showButton) {
      return null;
    }
    return html`
      <sp-button
        ?disabled=${this.disabled}
        variant="${variant}"
        href="${buttonLink}"
        @click=${() => {
          this.emitEvent('btnClick', {}, { bubbles: true, composed: true });
        }}
      >
        ${buttonText}
      </sp-button>
    `;
  }

  render() {
    const { iconSrc, description } = this;
    return html`
      <div class="empty-state-container">
        <img src=${iconSrc} class="empty-state-icon" name="icon"></slot>
        <div>${description}</div>
        ${this.renderButton()}
      </div>
    `;
  }
}
